import colorJog from '@ps/assets/animation/color_jog.png';
import displacementInching from '@ps/assets/animation/displacement_inching.png';
import rotaryJog from '@ps/assets/animation/rotary_jog.png';
import transparencyJog from '@ps/assets/animation/transparency_jog.png';
import zoomJog from '@ps/assets/animation/zoom_jog.png';
import i18n from '@ps/lang';
import pathConfig from '@ps/bridge/path';

export var AssetType = {
  ASSET_SCENE: 1,
  ASSET_PREFAB: 2,
  ASSET_ATLAS: 3,
  ASSET_TEXT: 4,
  ASSET_FONT: 5,
  ASSET_SOUND: 6,
  ASSET_EXCEL: 7,
  ASSET_WEBFONT: 8,
  ASSET_ACTION: 9,
  ASSET_ACTIONMANAGER: 10,
  ASSET_TS: 99,
  ASSET_JS: 100,
  ASSET_UNKNOWN: 101
};

export var AssetRoute = {
  SCENE: 'Temp', // 场景文件
  START: 'resource/start/start.bin', // 开始界面
  ENDING: 'resource/ending/ending.bin', // 结束界面
  GAME_ROOT: pathConfig.MAIN_PATH, // 游戏界面根目录

  WHITE_LIST_RES: pathConfig.WHITE_LIST_RES,
  WHITE_LIST_RES_GAME: pathConfig.WHITE_LIST_RES_GAME,
  WHITE_LIST_RES_ENDING: pathConfig.WHITE_LIST_RES_ENDING,
  NODE_UUID2RES: pathConfig.NODE_UUID2RES,
  BRAIN: pathConfig.BRAIN
};

export var ImageType = ['png', 'jpg', 'gif'];
export var AutoSaveSceneTimmer = 600; // 每10分钟自动保存，单位是秒
export var maxXlzSize = 8; // xlz最大限制 8M 一个
export var maxImageSize = 1; // 图片最大限制 1M 一个
export var maxVideoSize = 3; // 视频最大限制 3M 一个
export var maxAudioSize = 1; // 音效最大限制 1M 一个
export var maxDragonBoneSize = 1; // 龙骨最大限制 1M 一个
export var GamePage = {
  START: 'start',
  GAME: 'game',
  ENDING: 'ending',
  START_NODE_NAME: 'PlaySmartStart',
  END_NODE_NAME: 'PlaySmartEnd',
  GAMEPLAY: 'gamePlay',
  PREFAB: 'prefab'
};

export var tweenType = {
  position: 'qc.TweenPosition',
  alpha: 'qc.TweenAlpha',
  rotation: 'qc.TweenRotation',
  scale: 'qc.TweenScale',
  color: 'qc.TweenColor'
};

export var tweenLabel = [{
  label: i18n.t('workbench.animation.tweenLabel.alpha'),
  value: 'qc.TweenAlpha'
}, {
  label: i18n.t('workbench.animation.tweenLabel.position'),
  value: 'qc.TweenPosition'
}, {
  label: i18n.t('workbench.animation.tweenLabel.rotation'),
  value: 'qc.TweenRotation'
}, {
  label: i18n.t('workbench.animation.tweenLabel.scale'),
  value: 'qc.TweenScale'
}, {
  label: i18n.t('workbench.animation.tweenLabel.color'),
  value: 'qc.TweenColor'
}];

export var animationType = [{
  label: i18n.t('workbench.animation.animationType.in'),
  value: 1
}, {
  label: i18n.t('workbench.animation.animationType.out'),
  value: 2
}, {
  label: i18n.t('workbench.animation.animationType.strong'),
  value: 3
}];

var animationTagLabel = i18n.t('workbench.animation.animationTag');
export var animationTag = {
  approach: [{
    label: animationTagLabel[0],
    value: 1
  }, {
    label: animationTagLabel[1],
    value: 2
  }, {
    label: animationTagLabel[2],
    value: 3
  }, {
    label: animationTagLabel[3],
    value: 4
  }, {
    label: animationTagLabel[4],
    value: 5
  }, {
    label: animationTagLabel[5],
    value: 6
  }, {
    label: animationTagLabel[6],
    value: 7
  }, {
    label: animationTagLabel[7],
    value: 8
  }],
  exit: [{
    label: animationTagLabel[8],
    value: 9
  }, {
    label: animationTagLabel[9],
    value: 10
  }, {
    label: animationTagLabel[10],
    value: 11
  }, {
    label: animationTagLabel[11],
    value: 12
  }, {
    label: animationTagLabel[12],
    value: 13
  }, {
    label: animationTagLabel[13],
    value: 14
  }, {
    label: animationTagLabel[14],
    value: 15
  }, {
    label: animationTagLabel[15],
    value: 16
  }],
  stress: [{
    label: animationTagLabel[16],
    value: 17
  }, {
    label: animationTagLabel[17],
    value: 18
  }, {
    label: animationTagLabel[18],
    value: 19
  }, {
    label: animationTagLabel[19],
    value: 20
  }, {
    label: animationTagLabel[20],
    value: 21
  },
  // 强调-旋转
  {
    label: animationTagLabel[21],
    value: 22
  },
  // 强调-位移缩放
  {
    label: animationTagLabel[22],
    value: 23
  }]
};

export var builtinScript = [{
  name: '位移缓动',
  name_en: 'Displacement Easing',
  class_name: tweenType.position,
  image: displacementInching,
  from: {
    x: 0,
    y: 0
  },
  to: {
    x: 100,
    y: 100
  }
}, {
  name: '透明度缓动',
  name_en: 'Alpha Easing',
  class_name: tweenType.alpha,
  image: transparencyJog,
  from: 1,
  to: 0
}, {
  name: '旋转缓动',
  name_en: 'Spin Easing',
  class_name: tweenType.rotation,
  image: rotaryJog
}, {
  name: '缩放缓动',
  name_en: 'Scale Easing',
  class_name: tweenType.scale,
  image: zoomJog,
  from: {
    x: 1,
    y: 1
  },
  to: {
    x: 1.5,
    y: 1.5
  }
}, {
  name: '颜色变化',
  name_en: 'Color Change',
  class_name: tweenType.color,
  image: colorJog,
  from: '#ffffff', // 颜色值
  to: '#000000' // 颜色值
}];

export var scriptHideProperty = ['uuid', 'animationId', 'addType', 'tweenGroup', 'sampleMethod', 'flag', 'moveAxis', 'builtinId', 'builtinGroup'];

export var SymbolConfig = {
  width: 'px', // 宽度 单位像素
  height: 'px', // 高度 单位像素
  anchoredX: 'px', // 坐标X单位像素
  anchoredY: 'px', // 坐标Y单位像素
  pivotX: '', // 中心点X 单位像素
  pivotY: '', // 中心点Y 单位像素
  scaleX: '倍', // 缩放X 单位像素
  scaleY: '倍', // 缩放Y 单位像素
  rotation: '度', // 旋转度 单位角度
  alpha: '0~1', // 透明度，由于不是百分比，单位为空
  delay: 's', // 延后 单位秒
  duration: 's', // 时长 单位秒
  distanceX: 'px', // 距离X 单位像素
  distanceY: 'px', // 距离Y 单位像素
  interval: 'ms', // 序列帧每帧时间
  scale: '倍', // 整体缩放 单位像素
  left: 'px', // 左边距 单位像素
  right: 'px', // 右边距 单位像素
  top: 'px', // 上边距 单位像素
  bottom: 'px', // 下边距 单位像素
  centerX: 'px', // 中心点X偏移 单位像素
  centerY: 'px', // 中心点Y偏移 单位像素
  'qc.TweenAlphafrom': '%', // 透明度的 单元
  'qc.TweenAlphato': '%', // 透明度的 单元
  'qc.TweenRotationfrom': '°', // 旋转缓动 单元
  'qc.TweenRotationto': '°' // 旋转缓动 单元
};

export var GameState = {
  READY: 'ready',
  GAMESTART: 'gameStart',
  START: 'start',
  END: 'end',
  RETRY: 'retry',
  SCENECHANGE: 'scenechange'
};

export var NormalEvent = {
  VPEMITEVENT: 'VPEMITEVENT'
};

export var ScreenActionType = {
  SCREEN_DOWN: 'SCREEN_DOWN',
  SCREEN_UP: 'SCREEN_UP',
  SCREEN_SWIPE_ANY: 'SCREEN_SWIPE_ANY'
};

export var ScreenActionMap = {
  SCREEN_DOWN: 'onPointerDown',
  SCREEN_UP: 'onPointerUp',
  SCREEN_SWIPE_ANY: 'onPointerMove'
};

export var VirtualJoystick = {
  TOUCH_START: 'VirtualJoystick_TOUCH_START',
  UPDATE: 'VirtualJoystick_UPDATE',
  TOUCH_END: 'VirtualJoystick_TOUCH_END'
};

export var VPvariableDataType = [{
  serializer: 'qc.Serializer.NUMBER',
  type: 'number',
  serializerTypeValue: 3,
  label: '数字'
}, {
  serializer: 'qc.Serializer.STRING',
  type: 'string',
  serializerTypeValue: 7,
  label: '字符串'
}, {
  serializer: 'qc.Serializer.BOOLEAN',
  type: 'boolean',
  serializerTypeValue: 5,
  label: '布尔值'
}];

// 可视化编程异步方法列表
export var asyncMethod = ['vpWaitTime', 'vpSceneTransition'];

export var gamePlayTemplateScripts = ['Scripts/grid/view/GridView.js'];

export var box2dPlugins = [['../Plugins/com.qici.box2d/Script/lib/Box2D_v2.3.1_min.js', 'com.qici.box2d'], ['../Plugins/com.qici.box2d/Script/World.js', 'com.qici.box2d'], ['../Plugins/com.qici.box2d/Script/B2ObjectProxy.js', 'com.qici.box2d'], ['../Plugins/com.qici.box2d/Script/Body.js', 'com.qici.box2d'], ['../Plugins/com.qici.box2d/Script/Contact.js', 'com.qici.box2d'], ['../Plugins/com.qici.box2d/Script/DebugDraw.js', 'com.qici.box2d'], ['../Plugins/com.qici.box2d/Script/GeomUtil.js', 'com.qici.box2d'], ['../Plugins/com.qici.box2d/Script/OneWayPlatform.js', 'com.qici.box2d'], ['../Plugins/com.qici.box2d/Script/QueryAABB.js', 'com.qici.box2d'], ['../Plugins/com.qici.box2d/Script/Raycast.js', 'com.qici.box2d'], ['../Plugins/com.qici.box2d/Script/Root.js', 'com.qici.box2d']];

export var component2dConfig = {
  drawLine: {
    tab: 'drawLine',
    icon: IcConnect,
    text: i18n.t('workbench.drawLine.drawLine')
  },
  freeDrawLine: {
    tab: 'freeDrawLine',
    icon: IcFreeLine,
    text: i18n.t('workbench.drawLine.freeDrawLine')
  },
  erase: {
    tab: 'erase',
    icon: IcEraser,
    text: i18n.t('workbench.erase.erase')
  },
  mask: {
    tab: 'mask',
    icon: IcMask,
    text: i18n.t('workbench.mask.mask')
  },
  carousel: {
    tab: 'carousel',
    icon: IcCarouselView,
    text: i18n.t('workbench.carousel.component.title')
  }
};

export var quickLayoutComponent = {
  grid: 'grid', // 棋盘
  park: 'park',
  puzzle: 'puzzle',
  shelves: 'shelves'
};